import keycloak from "../keycloak";

// Single-flight guard around the redirect to Keycloak's login page.
//
// When an SSO session expires, the dashboard usually has several API requests in
// flight at once (KPI strip, matrix, widgets, …). Each one fails auth, each tries
// to refresh the (also-dead) token, and each then independently calls
// keycloak.login(). Several of those failures also bubble up to the global
// window.onerror / onunhandledrejection handlers, which call login() too.
//
// Every keycloak.login() builds a *fresh* authentication request (PKCE) and
// navigates, overwriting Keycloak's KC_RESTART cookie that anchors the in-progress
// login flow. The competing redirects leave the user on a login form whose
// authentication session is already stale, so Keycloak rejects the submit with
// "Your login attempt timed out. Login will start from the beginning." and the
// user has to sign in a second time.
//
// Funnelling every redirect through here guarantees exactly one login navigation
// per expiry event. Once login() triggers navigation the page unloads and this
// module state is discarded, so the guard naturally resets for the next session.
let redirecting = false;

export const redirectToLogin = (options) => {
  if (redirecting) {
    // A redirect is already underway; starting another would create a competing
    // Keycloak authentication session and invalidate the one the user will use.
    return;
  }
  redirecting = true;
  try {
    keycloak.login(options);
  } catch (err) {
    // login() never actually navigated — re-arm so a later attempt can redirect.
    redirecting = false;
    throw err;
  }
};

// Test-only: reset the module-level guard between cases.
export const __resetRedirectGuard = () => {
  redirecting = false;
};
